<template>
  <div class="white--text">
    <v-layout
      style="height: 20vh"
      class="secondary"
      row
      wrap
      justify-space-around
      align-content-center
    >
      <h1 id="skeleton">OUR SERVICES</h1>
    </v-layout>
    <v-container>
      <div v-for="content in data" :key="content[0]">
        <h2>
          {{ content[0] }}
        </h2>

        <p class="dwrapper">
          {{ content[1] }}
        </p>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [
        [
          "Avenues of Service",
          "We channel our commitment to service at home and abroad through five Avenues of Service, which are the foundation of club activity.",
        ],
        [
          "Club Service",
          "Club Service focuses on making clubs strong. A thriving club is anchored by strong relationships and an active membership development plan.",
        ],
        [
          "Vocational Service",
          "Vocational Service calls on every Rotarian to work with integrity and contribute their expertise to the problems and needs of society. Learn more in An Introduction to Vocational Service and the Code of Conduct.",
        ],
        [
          "Community Service",
          "Community Service encourages every Rotarian to find ways to improve the quality of life for people in their communities and to serve the public interest. Learn more in Communities in Action: A Guide to Effective Projects.",
        ],
        [
          "International Service",
          "International Service exemplifies our global reach in promoting peace and understanding. We support this service avenue by sponsoring or volunteering on international projects, seeking partners abroad, and more.",
        ],
        [
          "Youth Service",
          "Youth Service recognizes the importance of empowering youth and young professionals through leadership development programs such as Rotaract, Interact, Rotary Youth Leadership Awards, and Rotary Youth Exchange.",
        ],
      ],
    };
  },
};
</script>

<style>
#skeleton {
  animation: fadeInUp 1s ease-in-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(-100%);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

h2 {
  color: gold;
  margin: 1em auto;
}
p {
  color: rgb(238, 203, 116);
  font-weight: 500;
  font-size: 16.5px;
}
.dwrapper {
  padding: 2em;
  background-color: rgba(130, 130, 130, 0.2);
}
</style>